import type { ReactNode } from "react";
import { Alert, Button, Typography } from "@mui/material";
import { useMyProfile } from "../../../common/query/useMyProfile";
import { ProfileSummary } from "./ProfileSummary";

export function MeProfileSection({ standing }: { standing?: ReactNode }) {
  const profile = useMyProfile();
  if (profile.isLoading)
    return (
      <Typography color="text.secondary" role="status">
        Loading your profile…
      </Typography>
    );
  if (profile.isError || !profile.data)
    return (
      <Alert
        severity="error"
        action={
          <Button size="small" onClick={() => void profile.refetch()}>
            Retry
          </Button>
        }
      >
        Could not load your profile.
      </Alert>
    );
  return <ProfileSummary profile={profile.data} standing={standing} />;
}
